import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Box, Typography, Button, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper, TextField, IconButton
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import DialogShell from '../components/design-system/DialogShell';
import { fieldSx, labelSx, estiloTabla, btnPrimary } from '../styles/formStyles';

const API = process.env.REACT_APP_API_URL || '';

export default function ObrasSociales() {
  const rol = sessionStorage.getItem('rol') || '';
  const [lista, setLista] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editando, setEditando] = useState(null);
  const [nombre, setNombre] = useState('');
  const [error, setError] = useState('');

  useEffect(() => { cargar(); }, []);

  async function cargar() {
    try {
      const r = await axios.get(`${API}/api/obras-sociales`);
      setLista(r.data);
    } catch (err) { console.error(err); }
  }

  function abrirNuevo() { setEditando(null); setNombre(''); setError(''); setDialogOpen(true); }
  function abrirEditar(os) { setEditando(os.id); setNombre(os.nombre); setError(''); setDialogOpen(true); }
  function cerrar() { setDialogOpen(false); }

  async function guardar() {
    if (!nombre.trim()) { setError('El nombre es obligatorio'); return; }
    try {
      if (editando) {
        await axios.put(`${API}/api/obras-sociales/${editando}`, { nombre });
      } else {
        await axios.post(`${API}/api/obras-sociales`, { nombre });
      }
      cerrar();
      cargar();
    } catch (err) {
      setError(err.response?.data?.error || 'Error al guardar');
    }
  }

  async function eliminar(id) {
    if (!window.confirm('¿Eliminar esta obra social?')) return;
    try {
      await axios.delete(`${API}/api/obras-sociales/${id}`);
      cargar();
    } catch (err) {
      alert(err.response?.data?.error || 'Error al eliminar');
    }
  }

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <LocalHospitalIcon sx={{ color: 'var(--c-acento)' }} />
          <Typography variant="h5" sx={{ fontWeight: 700, color: 'var(--c-acento)' }}>
            Obras Sociales
          </Typography>
        </Box>
        <Button variant="contained" startIcon={<AddIcon />} onClick={abrirNuevo} sx={btnPrimary}>
          Nueva obra social
        </Button>
      </Box>

      <TableContainer component={Paper} sx={estiloTabla}>
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: 'var(--c-primario)' }}>
              <TableCell>Nombre</TableCell>
              <TableCell align="right">Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {lista.length === 0 ? (
              <TableRow>
                <TableCell colSpan={2} align="center" sx={{ color: '#b0b0b0', py: 4 }}>
                  No hay obras sociales registradas.
                </TableCell>
              </TableRow>
            ) : lista.map(os => (
              <TableRow key={os.id} sx={{ '&:hover': { bgcolor: 'var(--c-primario)' } }}>
                <TableCell sx={{ fontWeight: 500 }}>{os.nombre}</TableCell>
                <TableCell align="right">
                  <IconButton onClick={() => abrirEditar(os)} sx={{ color: 'var(--c-acento)' }} size="small">
                    <EditIcon fontSize="small" />
                  </IconButton>
                  {rol === 'admin' && (
                    <IconButton onClick={() => eliminar(os.id)} sx={{ color: '#f48fb1' }} size="small">
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <DialogShell
        open={dialogOpen}
        onClose={cerrar}
        maxWidth="xs"
        title={editando ? 'Editar obra social' : 'Nueva obra social'}
        subtitle="Nombre que aparecerá al registrar pacientes y turnos"
        actions={
          <>
            <Button onClick={cerrar} sx={{ color: 'var(--c-acento)' }}>Cancelar</Button>
            <Button variant="contained" onClick={guardar} sx={btnPrimary}>Guardar</Button>
          </>
        }
      >
        <Box>
          <Typography sx={labelSx}>Nombre *</Typography>
          <TextField
            fullWidth autoFocus value={nombre}
            onChange={e => { setNombre(e.target.value); setError(''); }}
            onKeyPress={e => e.key === 'Enter' && guardar()}
            sx={fieldSx}
            placeholder="Ej: OSDE, PAMI, Particular..."
          />
        </Box>
        {error && (
          <Typography sx={{ color: '#f44336', fontSize: 13, mt: 1 }}>{error}</Typography>
        )}
      </DialogShell>
    </Box>
  );
}
